import { render, staticRenderFns } from "./PointReward.vue?vue&type=template&id=b69c5906&scoped=true&"
import script from "./PointReward.vue?vue&type=script&lang=js&"
export * from "./PointReward.vue?vue&type=script&lang=js&"
import style0 from "./PointReward.vue?vue&type=style&index=0&id=b69c5906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69c5906",
  null
  
)

export default component.exports